import { useTranslation } from "react-i18next";

import { IconArrowRight, IconDownloadCloud01 } from "@pentabd/icons";
import { Button, Text } from "@pentabd/ui";

import { downloadFile } from "@helpers/getFilePreviewURL";

interface DepartmentCardType {
  id?: number;
  name?: string;
  icon?: string;
  bgImage?: string;
  badgeLabel?: string;
  badgeCount?: number;
  document: any;
  type?:
    | "default"
    | "primary"
    | "secondary"
    | "danger"
    | "warning"
    | "success"
    | "info";
}

export const ModuleCard = ({
  id,
  name,
  icon,
  bgImage,
  document,
}: DepartmentCardType) => {
  const { t } = useTranslation();

  return (
    <div
      className="pointer text-white rounded-8 border h-100"
      style={{
        backgroundImage: `url("${bgImage}")`,
        backgroundSize: "110% 130%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="h-100 d-flex justify-content-between align-items-center p-10">
        <div className="h-100 d-flex flex-column justify-content-between">
          <div>
            {name && (
              <Text
                component="h2"
                size="2xl"
                weight="bolder"
                className="text-white"
              >
                {t(name)}
              </Text>
            )}
            <div
              className="d-flex justify-content-start align-items-center pt-5 mb-6
          "
            >
              <Text>{t("MODULE.ENTER_BUTTON")} </Text>
              <IconArrowRight size={24} fill="light" />
            </div>
          </div>
          {document && (
            <a
              href={downloadFile(document?.documentId, document?.fileId)}
              // download={t(name as any)}
              target="_blank"
              rel="noreferrer"
              className="w-max"
            >
              <Button size="xs" fill="outline">
                {t("DASHBOARD.DOWNLOAD_MANUAL")}
                <IconDownloadCloud01 size="20" fill="white" />
              </Button>
            </a>
          )}
        </div>
        <div className="dashboard-image-container">
          {icon && <img src={icon} alt="department" className="h-100 w-100" />}
        </div>
      </div>
    </div>
  );
};
